var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          class: _vm.modalSizeClass,
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _c("i", { staticClass: "fa fa-gear" }),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("kanbanAttributes")))])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.dismiss.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _vm.attribute
              ? _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: _vm.uid + "_name" } }, [
                        _vm._v(_vm._s(_vm.$t("kanbanAttributeName")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attribute.name,
                            expression: "attribute.name"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: _vm.uid + "_name" },
                        domProps: { value: _vm.attribute.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.attribute, "name", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: _vm.uid + "_type" } }, [
                          _vm._v(_vm._s(_vm.$t("kanbanAttributeType")))
                        ]),
                        _vm._v(" "),
                        _c("vSelect", {
                          attrs: {
                            id: _vm.uid + "_type",
                            options: _vm.types,
                            label: "name",
                            reduce: t => t.id,
                            clearable: false,
                            appendToBody: true,
                            "calculate-position": _vm.vSelectInModalWithPopper
                          },
                          model: {
                            value: _vm.attribute.type,
                            callback: function($$v) {
                              _vm.$set(_vm.attribute, "type", $$v)
                            },
                            expression: "attribute.type"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.attribute.type ===
                      _vm.CardAttributeDefinitionType.Form && _vm.canScript
                      ? _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            { attrs: { for: _vm.uid + "_metadata" } },
                            [_vm._v(_vm._s(_vm.$t("kanbanAttributeMetaData")))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.metaData,
                                expression: "metaData"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: _vm.uid + "_metadata" },
                            domProps: { value: _vm.metaData },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.metaData = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.attribute.type === _vm.CardAttributeDefinitionType.Form
                      ? _c("VueFormBuilder", {
                          model: {
                            value: _vm.vueFormMetaData,
                            callback: function($$v) {
                              _vm.vueFormMetaData = $$v
                            },
                            expression: "vueFormMetaData"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: _vm.saving },
                  on: { click: _vm.save }
                },
                [
                  _vm.saving
                    ? _c("Spinner", { attrs: { small: true } })
                    : _vm._e(),
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("btnSave")) + "\n        "
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }